import { useNavigate } from "react-router-dom";
import { ReportsMineData } from "../types/reportsMine.type";
import { ArrowBigRight } from "lucide-react";
import TextWithTooltip from "@/common/components/TextWithTooltip";

export interface ReportsGridItemProps {
  report: ReportsMineData;
}

const ReportsGridItem = ({ report }: ReportsGridItemProps) => {
  const navigate = useNavigate();

  return (
    <div
      key={report.id} className="flex flex-col justify-between bg-white-200 rounded-lg p-4 gap-4 h-[200px] cursor-pointer"
      onClick={() => navigate(`/reports/create?generator_klass=${report.generator_klass}`)}
    >
      <div className="flex flex-col gap-4">
        <div>
          <p className="text-xs font-light italic">
            Título do relatório
          </p>

          <p className="text-sm">
            {report.title || '--'}
          </p>
        </div>

        <div>
          <p className="text-xs font-light italic">
            Descrição do relatório
          </p>

          <TextWithTooltip
            content={report?.description}
            maxLength={100}
            className="text-sm text-ellipsis line-clamp-2"
          />
        </div>
      </div>

      <div className="flex justify-end items-center">
        <ArrowBigRight />
      </div>
    </div>
  );
}

export default ReportsGridItem;
